import { Company } from '@/gen/inventory/v1/company_service_pb'
import { OngoingAssessment } from '@/gen/inventory/v1/ongoing_assessment_pb'

import type { GroupingMetadata } from '@/components/lemmala-design-system/table/types'

export const INVENTORY_PREFIX = 'inventory' as const
export const ENGAGEMENTS_PREFIX = 'engagements' as const

export const INVENTORY_COLUMN_IDS = {
  risk: 'risk',
  profileName: 'profile.name',
  lifecycle: 'lifecycle',
  assessmentScore: 'assessmentScore',
  tagIds: 'tagIds',
  alertsByLevel: 'alertsByLevel',
  sources: 'sources',
  usage: 'usage',
  createdAt: 'createdAt',
  businessOwnerName: 'businessOwnerName',
  status: 'status',
  irStatus: 'irStatus',
  assessmentDue: 'assessmentDue',
  assessmentDueDate: 'assessmentDueDate',
  aiPosture: 'aiPosture',
  aiCapabilities: 'aiCapabilities',
  modelProvider: 'modelProvider',
  supportAIActions: 'supportAIActions',
} as const

// Extended row data used by the AG Grid inventory table.
// Adds optional, UI-specific fields that may be derived or aggregated server-side.
export type CompanyRow = Company & {
  totalQuestionnaires?: number
  ongoingAssessments?: OngoingAssessment[]
} & Partial<GroupingMetadata>
